import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPPurchaseWriteOffActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/WriteOff/WriteOffBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceAPPurchaseWriteOff"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPPurchaseWriteOff"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPPurchaseWriteOffActivity)
